import React from 'react';
import './SuccessFactorsContent.css';
import Recimg from '../../assets/images/Recruitment.png'; 

const SuccessFactorsContent = () => {
  return (
    <section className="sf-content-section">
      <div className="container">
        {/* Top Intro Section */}
        <div className="sf-intro-grid">
          <div className="sf-intro-image-container">
            <img 
              src={Recimg}
              alt="SAP Success Factors Consulting" 
              className="sf-intro-image"
            />
          </div>
          <div className="sf-intro-text">
            <h2 className="sf-intro-title">SAP Success Factors Consulting & HR Solutions</h2>
            <p>
              NEUROVERSE AI offers a comprehensive SAP SuccessFactors implementation service in the USA, providing custom solutions for businesses to optimize their HR processes. With expertise in SAP SuccessFactors Talent Management, we empower organizations to enhance employee performance and drive growth. Our SAP SuccessFactors Consulting Services ensure seamless integration and customization, delivering HR solutions that meet your business needs. Trust NEUROVERSE AI for Superior SAP SuccessFactors HR Software in the USA and SAP SuccessFactors HR Solutions in the UAE, designed to streamline your HR operations and improve workforce management.
            </p>
          </div>
        </div>

        {/* Features Grid Section */}
        <div className="sf-features-grid">
          <div className="sf-feature-card">
            <h3>Expert Guidance for Successful Implementation</h3>
            <p>
              Implementing an HR system like SAP SuccessFactors can be complex, so our SAP SuccessFactors consulting services are designed to provide businesses with expert guidance at every stage of the process. From system configuration to data migration and system integration, our team of consultants is here to help you navigate the challenges of adopting new technology.
            </p>
          </div>
          <div className="sf-feature-card">
            <h3>Unlock the Power of Talent Management</h3>
            <p>
              SAP SuccessFactors is renowned for its robust talent management features that help organisations build stronger, more capable teams. We guide you in utilising advanced modules such as recruitment, onboarding, learning, performance management, and succession planning to attract, develop, and retain top talent.
            </p>
          </div>
          <div className="sf-feature-card">
            <h3>Comprehensive SAP SuccessFactors Services</h3>
            <p>
              In addition to implementation and consulting, we offer the best SAP SuccessFactors courses online for professionals looking to advance their skills. Our programs are designed for individuals at all levels, from those new to the platform to experienced professionals seeking to deepen their expertise.
            </p>
          </div>
          <div className="sf-feature-card">
            <h3>Achieve SAP Excellence with Neuroverse AI</h3>
            <p>
              At Neuroverse AI, we aim to help organisations optimise their HR processes with SAP SuccessFactors. From initial implementation to ongoing consulting, talent management, and services, we provide a full suite of services designed to improve workforce efficiency and employee outcomes.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SuccessFactorsContent;
